module.exports = __webpack_public_path__ + "img/shared-hosting.3e5cea1e.svg";